export default class CreativeService {
  protected static readonly macroRegex = /{{CLICK_URL(_ESC)?}}/;

  public static hasClickUrlMacro(tag: string | null): boolean {
    if (!tag) {
      return false;
    }
    return this.macroRegex.test(tag);
  }
}
